import RelatedContentGridLoadMore from './RelatedContentGridLoadMore.vue';

bootVue('.vue-related-content-grid-load-more', RelatedContentGridLoadMore);
